module.exports = __webpack_public_path__ + "img/gate_timedout_badge.acf3c38.svg";